import React, { FC, useMemo } from 'react';
import { useTheme } from '@mui/material';
import Widget from 'src/components/Widget';
import { ApiServiceImpl } from 'src/api/services';
import AccountStatusContent from './Content';
import { TimeSpan } from 'src/viewsTypes';
import { DashboardDataStatus } from 'src/api/services/types';
import LoadingSkeleton from 'src/components/LoadingSkeleton';

const title = 'סטאטוס חשבון';
type DataType = Pick<DashboardDataStatus, 'score' | 'violatingCount'>;

const AccountStatus: FC = () => {
  const { spacing } = useTheme();
  const timeSpan: TimeSpan = useMemo(() => ({ timeUnit: 'M', count: 3 }), []);
  const size = useMemo(
    () => ({ width: spacing(42), height: spacing(40) }),
    [spacing],
  );

  return (
    <Widget<DataType>
      title={title}
      size={size}
      filters={{ timeSpan }}
      service={ApiServiceImpl.getAccountStatus}
      Content={AccountStatusContent}
      LoadingSkeleton={<LoadingSkeleton height="60%" />}
    />
  );
};

export default AccountStatus;
